import "./App.css";
import { useEffect, useState } from "react";
import Header from "./components/Header";
import TabGroup from "./components/TabGroup";
import "../src/css/Grid.css";
import Feed from "./components/Feed";
import { retrieveUser } from "./api/retrieveUser";
import GoogleAnalyticsScript from "./components/GoogleAnalyticsScript";
import { genericLog } from "./api/genericLog.js";

import { useLocation, useNavigate } from "react-router-dom";

const defaultSocial = "INSTAGRAM";
const nonDefaultSocial = "TIKTOK";
const cleanString = (s) => (!s ? "" : s);

/**
 * Retrieve the user from the backend.  If the user has
 * been disabled, return will be {}
 * @param {} param0
 * @returns
 */
export async function loadUser(username, wpApiKey) {

  const dirtyUser = await retrieveUser(username, wpApiKey);
  if (dirtyUser === "{}") {
    return undefined;
  } else {
  	 const dirtyUserButtonList = dirtyUser.data.Item.userButtonList;
     const cleanUserButtonList = dirtyUserButtonList.map((item) => {
          return {
            buttonId: item.SK.S,
            url: item.url.S,
            text: item.text.S,
            order: parseInt(item.order.N, 10),
          };
        });


    const profilePicObjectKey = dirtyUser.data.Item.profilePicObjectKey;
    const welcome = dirtyUser.data.Item.welcome || "";
    const profilePicUrl =
      profilePicObjectKey !== undefined
        ? `https://${process.env.REACT_APP_DOMAIN}/${profilePicObjectKey}`
        : undefined;

        const cleanUser = {
          userButtonList: cleanUserButtonList,
          userId: dirtyUser.data.Item.PK,
          username: dirtyUser.data.Item.username || "",
          profilePicUrl: profilePicUrl,
          welcome: welcome,
          profilePageDisclosure: dirtyUser.data.Item.profilePageDisclosure || "",
          subImageLinksAction: dirtyUser.data.Item.subImageLinksAction || "",
          subImageLinksDisclosure:
          dirtyUser.data.Item.subImageLinksDisclosure || "",
          fbEnabled: dirtyUser.data.Item.igStatus === "enabled",
          tiktokEnabled: dirtyUser.data.Item.tiktokStatus === "enabled",
          metaPixelId: dirtyUser.data.Item.metaPixelId,
          base_subscription: dirtyUser.data.Item.base_subscription,
          igAspectRatio: dirtyUser.data.Item.igAspectRatio
        };
	console.log(`Clean user = ${JSON.stringify(cleanUser)}`);
    return cleanUser;
  }
}

function App({username, wpApiKey}) {
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const initialTab = query.get("tab") === "tiktok" ? "TIKTOK" : "INSTAGRAM";
  const [selectedSource, setSelectedSource] = useState(initialTab);
  useEffect(() => {
    const fetchUser = async () => {
      const userData = await loadUser(username, wpApiKey);
      setUser(userData);
    };
    fetchUser();
  }, []);

  if (!user) {
    return null;
  }

  const handleTabChange = (source) => {
    setSelectedSource(source);
  };

  return (
    <>
    <div id="gtl-root">
      <div className="react-style-root">
      	<GoogleAnalyticsScript />
     	<Header user={user} wpApiKey={wpApiKey} />
     	<div className="gtl-container">
     	{user.fbEnabled && user.tiktokEnabled && (
     		<div className="tab-group">
        	<TabGroup onTabChange={handleTabChange} activeTab={selectedSource} />
        	</div>
      )}
      {selectedSource === "INSTAGRAM" && user.fbEnabled && (
        <Feed user={user} source={"INSTAGRAM"} />
      )}
      {selectedSource === "TIKTOK" && user.tiktokEnabled && (
        <Feed user={user} source={"TIKTOK"} />
      )}
      </div>
      </div>
       </div>

    </>
  );


}

const isInAppBrowser = (social, userAgent, referrer) => {
  const ua = cleanString(userAgent).toUpperCase();
  const ref = cleanString(referrer).toUpperCase();
  genericLog('ua=',ua, 'referrer=',ref);

  if (social === "TIKTOK") {
      genericLog('TikTokBrowserDetected');
      return (
      ua.includes("TTWEBVIEW") ||
      ua.includes("TIKTOK") ||
      ua.includes("BYTEDANCE") ||
      ref.includes("TIKTOK.COM") ||
      ref.includes("CHIPMUNK")
    );
  }

  if (social === "INSTAGRAM") {
    genericLog(`User Agent: ${userAgent}, Referrer: ${referrer}`);
    if (ua.includes("INSTAGRAM") || ref.includes("INSTAGRAM")) {
      genericLog("InstagramBrowserDetected");
      return true;
    }
  }

  return false;
};



export default App;
